import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class RestorePasswordPage {
    constructor(modalController, toolsService, authService, analyticsService) {
        this.modalController = modalController;
        this.toolsService = toolsService;
        this.authService = authService;
        this.analyticsService = analyticsService;
        this.analyticsService.AnalyticsServiceModalView('restore-password');
        this.loadForm();
    }
    ngOnInit() {
    }
    //Function to close modal
    closeModal() {
        this.modalController.dismiss();
    }
    //Function to load Forms
    loadForm() {
        this.restorePasswordQuestions = [
            { label: 'E-mail', format: 'input', type: 'email', formControl: new FormControl('', [Validators.required, Validators.pattern(/.*@.*\..*/)]) },
        ];
    }
    // Function to send restore password email
    sendRestorePasswordEmail() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.toolsService.validateQuestions(this.restorePasswordQuestions)) {
                yield this.toolsService.showLoader();
                try {
                    yield this.authService.sendRestorePasswordEmail(this.restorePasswordQuestions[0].formControl.value);
                    this.toolsService.showSuccessToast('Correo enviado con éxito. ¡Recuerda revisar en el correo de spam!');
                    yield this.toolsService.dismissLoader();
                }
                catch (error) {
                    this.toolsService.showErrorToast();
                    console.error('[RESTORE-PASSWORD-PAGE] sendRestorePasswordEmail()');
                    yield this.toolsService.dismissLoader();
                }
                this.closeModal();
            }
            else {
                this.toolsService.markAsTouched(this.restorePasswordQuestions);
            }
        });
    }
}
